const initialState = {
	cardNumber: '',
	cardHolderName: '',
	expireDate: '',
	cvc: '',
	selectedInstallment: 0,
	is3DPayment: false,
	isPaymentWithRegisteredCard: false,
	currentStep: 0,
	isMobile: false,
	stepsLocked: true
};

export {
	initialState
};
